import styled from "styled-components";

import { UploadSuppressionListButton } from "../../../../../pages/management/components/ManagementSections/components/UploadSuppressionListButton/UploadSuppressionListButton";

export const StyledUploadSuppressionListButton = styled(UploadSuppressionListButton)`
    justify-content: center;
    flex-grow: 1;

    & > div {
        flex-grow: unset;
    }
`;
